<template>
  <main class="common-container">
    <section class="page-title flash-title common-padding">
      <h2>{{ $t("chart1.metaChart") }}</h2>
    </section>

    <section class="explanation-container center">
      <img :src="explainImg" alt="" />
    </section>

    <section class="explanation-container center">
      <ul class="color-circle">
        <li class="color-circle__item">
          <p v-html="$t('metaExp.content1.descText2')"></p>
        </li>
        <li class="color-circle__item">
          <p v-html="$t('metaExp.content1.descText3')"></p>
        </li>
        <li class="color-circle__item">
          <!-- <p v-html="$t('metaExp.content1.descText4')"></p> -->
          <!-- <p>Capture chart screen and view with screen zoom.</p> -->
          <p v-html="$t('metaExp.content1.descText16')"></p>
        </li>
        <li class="color-circle__item">
          <p v-html="$t('metaExp.content1.descText17')"></p>
        </li>
        <li class="color-circle__item">
          <p v-html="$t('metaExp.content1.descText18')"></p>
        </li>
        <div class="sub-sentence-box">
          <h3>• {{ $t("chart1.kibotLine") }}</h3>
          <p class="sentence22" v-html="$t('metaExp.content1.descText5')"></p>
          <p class="sentence22" v-html="$t('metaExp.content1.descText6')"></p>
          <p class="sentence22" v-html="$t('metaExp.content1.descText7')"></p>
          <p class="sentence22" v-html="$t('metaExp.content1.descText8')"></p>
        </div>
        <div class="sub-sentence-box">
          <h3>• {{ $t("chart1.trend") }}</h3>
          <p class="sentence22" v-html="$t('metaExp.content1.descText15')"></p>
        </div>
        <div class="sub-sentence-box">
          <h3>• {{ $t("chart1.sr") }}</h3>
          <p class="sentence22" v-html="$t('metaExp.content1.descText11')"></p>
        </div>
        <div class="sub-sentence-box">
          <h3>• {{ $t("chart1.heikin") }}</h3>
          <p class="sentence22" v-html="$t('metaExp.content1.descText9')"></p>
        </div>
        <div class="sub-sentence-box">
          <h3>• {{ $t("chart1.3ma") }}</h3>
          <p class="sentence22" v-html="$t('metaExp.content1.descText10')"></p>
        </div>
        <div class="sub-sentence-box">
          <h3>• {{ $t("chart1.bb") }}</h3>
          <p class="sentence22" v-html="$t('metaExp.content1.descText12')"></p>
        </div>
        <div class="sub-sentence-box">
          <h3>• {{ $t("chart2.RSI") }}</h3>
          <p class="sentence22" v-html="$t('metaExp.content1.descText13')"></p>
        </div>
        <div class="sub-sentence-box">
          <h3>• MACD</h3>
          <p class="sentence22" v-html="$t('metaExp.content1.descText14')"></p>
        </div>
      </ul>
    </section>
  </main>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from "vue";
import { useResolutionStore } from "@/store/useResolution";
import metaImg from "@/assets/images/pages/explanation/meta/meta_explanation.png";
import metaMImg from "@/assets/images/pages/explanation/meta/meta_explanation-m.png";

const resolutionStore = useResolutionStore();
const isMobile = computed(() => resolutionStore.isMobile);
// isMobile 값이 변경될 때 자동으로 업데이트됨
const explainImg = computed(() => (isMobile.value ? metaMImg : metaImg));

const updateWindowSize = () => {
  resolutionStore.setSize({ width: window.innerWidth });
};

onMounted(() => {
  window.addEventListener("resize", updateWindowSize);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWindowSize);
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pages/explanation/common_explanation.scss";
</style>
